/*global chrome*/
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BackHandOutlinedIcon from "@mui/icons-material/BackHandOutlined";
import CallIcon from "@mui/icons-material/Call";
import {
  capitalize,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import { ChevronDown } from "lucide-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SpeechRecognition from "react-speech-recognition";
import { toast } from "react-toastify";
import credits_exhausted from './Images/exhausted.svg';
import "./style.css";
import EditModal from "./utilities/EditModal";
import { StarLoader } from "./utilities/AILoader.jsx";
import KeepBotDialog from "./utilities/KeepBotDialog.jsx";
import * as microsoftTeams from "@microsoft/teams-js";

axios.defaults.withCredentials = true;

const VoiceToText = () => {
  const [socket, setSocket] = useState(null);
  // const [receivedData, setReceivedData] = useState({ massage: [{ username: "", message: ["This is for the Testing purpose and let", "This is another message"] }] });
  const [receivedData, setReceivedData] = useState({
    massage: [],
    summary: null,
  });

  const [sessionData, setSessionData] = useState([]);
  // const [isMuted, setIsMuted] = useState(false);
  const navigate = useNavigate();
  // State to manage whether speech recognition is active or not
  const [isListening, setIsListening] = useState(true);

  // State to manage the visibility of the list
  const [showList, setShowList] = useState(false);

  // const [micAccessGranted, setMicAccessGranted] = useState(true);
  // const [error, setError] = useState(null);
  // const [wordsAvailable, setWordsAvailable] = useState(false);
  // const [word, setWord] = useState({ message: [] });
  // const [result, setResult] = useState({ massage: [] });
  // const [open, setOpen] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);
  // const [discussion, setDiscussion] = useState("");
  const bottomRef = useRef(null);
  // const [isLoading, setIsLoading] = useState(true);
  const [tooltipHead, setTooltipHead] = useState("");
  const [type, setType] = useState("");
  // const [tooltipWidth, setTooltipWidth] = useState("auto");

  const [meaning, setMeaning] = useState("");
  // const [listen, setListen] = useState(true);
  // const [top, setTop] = useState(0);
  // const [left, setLeft] = useState(0);
  // const [isIntervalRunning, setIsIntervalRunning] = useState(false);
  const [isBotJoined, setIsBotJoined] = useState(false);

  const clickTimer = useRef(null);

  const ext_backend = process.env.REACT_APP_PORT_8000;
  const ext_websocket = process.env.REACT_APP_WEBSOCKET;
  const dashboard_backend = process.env.REACT_APP_DASHBOARD_BACKEND;
  const dashboard_redirect = process.env.REACT_APP_DASHBOARD_REDIRECT;
  // const [isUserScrolling, setIsUserScrolling] = useState(false);
  const transcriptContainerRef = useRef(null);
  // const dispatch = useDispatch();

  // const [scrollPosition, setScrollPosition] = useState(0);

  const [edit, setEdit] = useState(false);
  // const [displayedText, setDisplayedText] = useState("");

  // For Time exceed and No transcript found
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  // const [dialogResponse, setDialogResponse] = useState("");
  const [botLeaved, setBotLeaved] = useState(false);

  const [searchInput, setSearchInput] = useState(""); // User typing
  const [searchText, setSearchText] = useState(""); // Actual search triggered on button
  // const [searchFocused, setSearchFocused] = useState(null);
  const [matchRefs, setMatchRefs] = useState([]); // all matches
  const [currentMatchIndex, setCurrentMatchIndex] = useState(0);
  const tempRefs = useRef([]); // used during render
  // const [openSearch, setOpenSearch] = useState(false);

  useEffect(() => {
    const refs = tempRefs.current.filter(Boolean);
    setMatchRefs(refs);
  }, [searchText, receivedData]);

  React.useEffect(() => {
    if (searchInput.trim() === "") {
      setSearchText("");
      setCurrentMatchIndex(0);
      tempRefs.current = [];
    }
  }, [searchInput]);

  useEffect(() => {
    if (matchRefs[currentMatchIndex]) {
      matchRefs[currentMatchIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [currentMatchIndex, matchRefs]);

  useEffect(() => {
    const allRefs = tempRefs.current.map((r) => r.current).filter(Boolean);
    setMatchRefs(allRefs);
  }, [searchText, receivedData]);

  // Rotating placeholder for search input
  const [searchPlaceholder, setSearchPlaceholder] = useState("Ask Lizy");
  useEffect(() => {
    let active = true;
    let idx = 0;
    const placeholders = ["Ask Lizy", "Search @mentions"];
    const rotate = () => {
      setSearchPlaceholder(placeholders[idx % placeholders.length]);
      idx++;
    };
    const interval = setInterval(() => {
      if (active) rotate();
    }, 3000);
    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  const [hasShownMeaning, setHasShownMeaning] = useState(false);
  useEffect(() => {
    if (meaning && !hasShownMeaning) {
      setHasShownMeaning(true);
    }
  }, [meaning, hasShownMeaning]);

  const CustomTooltip = useMemo(
    () =>
      styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))({
        [`& .MuiTooltip-tooltip`]: {
          position: "absolute",
          top: "170px",
          left: "15px",
          background: "transparent",
          fontSize: "0.875rem",
          margin: "0px",
          padding: "0px",
          overflow: "hidden",
        },
      }),
    []
  );

  // Add these refs at the top of your component with other refs
  const isAtBottomRef = useRef(true);
  const scrollPositionRef = useRef(0);
  const userInteractedRef = useRef(false);
  const [showScrollButton, setShowScrollButton] = useState(false);
  // Revised handleScroll function
  const handleScroll = () => {
    if (!transcriptContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = transcriptContainerRef.current;
    const isAtBottom = scrollHeight - scrollTop - clientHeight < 10;

    // Update ref for immediate access in effects
    isAtBottomRef.current = isAtBottom;

    // Also update state for UI that might depend on it
    // setIsUserScrolling(!isAtBottom);

    if (!isAtBottom) {
      // setScrollPosition(scrollTop);
      scrollPositionRef.current = scrollTop;
      userInteractedRef.current = true;
      setShowScrollButton(true);
    } else {
      userInteractedRef.current = false;
      setShowScrollButton(false);
    }
  };
  const scrollToBottom = () => {
    const el = transcriptContainerRef.current;
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    }
  };
  // Revised useEffect for new messages
  useEffect(() => {
    if (transcriptContainerRef.current && bottomRef.current) {
      // Use the ref value which is always up-to-date
      if (isAtBottomRef.current && !userInteractedRef.current) {
        setTimeout(() => {
          if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      }
    }
  }, [receivedData.massage]);

  // Revised useEffect for showList changes
  useEffect(() => {
    if (showList && transcriptContainerRef.current) {
      setTimeout(() => {
        if (isAtBottomRef.current) {
          // If user was at bottom, scroll to bottom
          if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          // Otherwise restore the previous scroll position
          transcriptContainerRef.current.scrollTop = scrollPositionRef.current;
        }
      }, 50);
    }
  }, [showList]);

  // Add this useEffect to handle initial scroll to bottom
  useEffect(() => {
    if (transcriptContainerRef.current && bottomRef.current && isAtBottomRef.current) {
      setTimeout(() => {
        bottomRef.current.scrollIntoView({ behavior: "instant" });
      }, 100);
    }
  }, []);




  // Toggle the visibility of the list

  // working as switch
  const handleToggleClick = () => {
    setShowList((prevShowList) => !prevShowList);
  };

  // // Synchronization of our google meet controls  01-11-2024
  // const checkIsMuted = () => {
  //   const handleMessage = (message, sender, sendResponse) => {
  //     if (message.type === "sync-state") {
  //       // Update the listening state based on the mute state
  //       if (message.isMuted) {
  //         setIsListening(false);
  //         SpeechRecognition.stopListening();
  //       } else {
  //         setIsListening(true);
  //         SpeechRecognition.startListening({
  //           continuous: true,
  //           language: "en-US",
  //         });
  //       }

  //       // Check if the user is leaving
  //       if (message.isLeaving) {
  //         exitRoom(); // Handle room exit
  //       }

  //       // Simulate asynchronous processing, then send a response
  //       setTimeout(() => {
  //         sendResponse({ status: "success" });
  //       }, 1000);

  //       // Indicate that we're sending a response asynchronously
  //       return true;
  //     }

  //     // Handle other message types if needed
  //     if (message.type === "leave-call") {
  //       exitRoom(); // Handle room exit for leave call
  //       setTimeout(() => {
  //         navigate("/wrap-up");
  //       }, 1000);
  //       sendResponse({ status: "success" });
  //       return true;
  //     }
  //   };



  //   // Add the message listener
  //   chrome.runtime.onMessage.addListener(handleMessage);

  //   // Cleanup: Remove the listener when the component unmounts
  //   return () => {
  //     chrome.runtime.onMessage.removeListener(handleMessage);
  //   };
  // };

  useEffect(() => {
    // comment @prosenjit for running local
    // checkIsMuted();
  }, []);

  // To check the intital state of the meet mute btn 01-11-2024
  // commented @prosenjit for run in local
  // useEffect(() => {
  //   // Change
  //   chrome.storage.local.get(["isMuted"], (result) => {
  //     setIsListening(!result.isMuted);
  //     result.isMuted ? setIsMuted(true) : setIsMuted(false);
  //   });
  // }, []);

  // For sending the message to chrome for googlemeet  working
  // function sendMessageToActiveTab(action) {
  //   if (chrome && chrome.tabs && chrome.tabs.query) {
  //     chrome.tabs.query({ active: true, currentWindow: true }, (tabs) => {
  //       if (tabs[0] && tabs[0].id) {
  //         chrome.tabs.sendMessage(
  //           tabs[0].id,
  //           { action: action },
  //           (response) => {
  //             if (chrome.runtime.lastError) {
  //               console.error(
  //                 "Error sending message:",
  //                 chrome.runtime.lastError
  //               );
  //             }
  //           }
  //         );
  //       } else {
  //         console.error("No active tab found");
  //       }
  //     });
  //   } else {
  //     console.error("chrome.tabs API is not available");
  //   }
  // }

  // =====================Exit Room code start ===============================
  const exitRoom = () => {
    let api = `${ext_backend}exitroom/`; //code change for testing
    axios
      .get(api, { withCredentials: true })
      .then((res) => {
        // sendMessageToActiveTab('exit')   //making chages
        setReceivedData({ massage: [] });
        // dispatch(transcription(transcript))

        sessionStorage.removeItem("roomcode");
        sessionStorage.removeItem("meeting_active");
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("team_name");
        sessionStorage.removeItem("team_id");
        sessionStorage.removeItem("liznr_added");
        // chrome.storage.local.set({ callEnded: false }, () => {
        //   // This callback will execute after the data is successfully written to chrome.storage.local
        //   console.log('callEnded status has been updated');
        // });
        // chrome.storage.local.remove("url", () => {
        //   console.log("URL has been removed from chrome.storage.local");
        // });
        navigate("/");

        // navigate('/summarize')
      })
      .catch((error) => {
        console.error("Error retrieving data:", error);
      });
  };
  // =====================Exit Room code end ===============================

  //==============================Get Session Data code start ====================
  useEffect(() => {
    let api = `${ext_backend}sessionget/`; //code change for testing
    const user = sessionStorage.getItem("username");
    const roomcode = sessionStorage.getItem("roomcode");

    const params = {
      username: user,
      roomcode: roomcode,
    };

    axios
      .get(api, { withCredentials: true, params: params })
      .then((res) => {
        setSessionData(res.data.data);
      })
      .catch((error) => {
        console.error("Error retrieving data:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //==============================Get Session Data code end =============================================================================

  //===============================speech recognition code start =============================================================================
  // Function to start listening
  const handleStartListening = () => {
    SpeechRecognition.startListening({ continuous: true, language: "en" });
    setIsListening(true);
    // sendMessageToActiveTab("muteBtn");
  };

  // Function to stop listening
  const handleStopListening = () => {
    SpeechRecognition.stopListening();
    setIsListening(false);
    // sendMessageToActiveTab("muteBtn");
  };

  // Start listening automatically when component mounts
  // useEffect(() => {
  //   if (!isMuted) {
  //     SpeechRecognition.startListening({ continuous: true, language: "en" });
  //     setIsListening(true);
  //   } else {
  //     SpeechRecognition.stopListening();
  //     setIsListening(false);
  //   }
  //   // Cleanup function to stop listening when the component unmounts
  //   return () => {
  //     SpeechRecognition.stopListening();
  //     setIsListening(false);
  //   };
  // }, []);

  // Need To comment
  // SpeechRecognition.startListening({ continuous: true, language: 'en' });

  // const { transcript, interimTranscript, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
  // const data = useSelector((state) => state.createRoom.inputValues)

  // ==============================speech recognition code end =============================================================================

  //==============================websocket connection code start =======================================================================
  useEffect(() => {
    if (sessionData.roomcode) {
      const newSocket = new WebSocket(
        `${ext_websocket}${sessionData.roomcode}`
      );
      setSocket(newSocket);
      return () => {
        newSocket.close();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.roomcode]);
  //==============================websocket connection code end ======================================================================================

  //==========websocket event code like websocket connect massages received and send and close start ==================================================================
  useEffect(() => {
    if (!socket) return;

    socket.onopen = () => {
      const username = sessionStorage.getItem("username");
      const org_detail = sessionStorage.getItem("Organization_detail");
      const team_name = sessionStorage.getItem("team_name");
      const role = sessionStorage.getItem("role");
      const display_name = sessionStorage.getItem("display_name");

      if (org_detail && team_name && role) {
        const initialData = JSON.stringify({
          message: `${display_name || username} has joined`,
          action: "join",
          username: username,
          display_name: display_name,
          organization: org_detail,
          team_name,
          role,
        });

        socket.send(initialData); // Send data to the WebSocket server
      } else if (username && display_name) {
        const message = JSON.stringify({
          message: `${display_name || username} has joined`,
          action: "anonymous",
          username: username,
          display_name: display_name,
        });
        socket.send(message); // Send data to the WebSocket server
      }
      console.log("WebSocket connection established.");
    };

    socket.onmessage = (event) => {
      try {
        const received = JSON.parse(event.data);


        if (received && received.massage && received.massage.length > 0) {
          const chunk = received.massage[0];
          const isInterim = received.interim === true;
          const user = received.username;
          const display_name = received.display_name;
          const summary = received.summary;
          const data = JSON.parse(summary)
          let cleanSummary = received.summary;

          // Handle weird string cases
          if (
            cleanSummary === "\"\"" ||          // double-encoded empty string
            cleanSummary === "[]" ||            // empty array
            cleanSummary === "" ||              // plain empty
            cleanSummary === null ||            // null
            cleanSummary === undefined          // undefined
          ) {
            cleanSummary = null;
          } else {
            // Try to parse if it's JSON-encoded (e.g. "\"Some text\"" or "{\"summary\":\"...\"}")
            try {
              const parsed = JSON.parse(cleanSummary);
              // If it's a simple string (like "\"Hello\""), use it
              if (typeof parsed === "string") {
                cleanSummary = parsed.trim();
              } else if (Array.isArray(parsed) && parsed.length === 0) {
                cleanSummary = null;
              } else if (parsed?.summary) {
                cleanSummary = parsed.summary;
              }
            } catch {
              // if not parsable, just leave as-is
            }
          }

          // Now final fallback
          const innerContent =
            data?.summary?.replace(/^Summary:\s*/, "") ||
            (cleanSummary === "" || cleanSummary === null ? null : cleanSummary);

          const timestamp = new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          });
          console.log("Test innercontent", innerContent);
          // --- INTERIM LOGIC ---
          setReceivedData((prevData) => {
            const prevMsgs = prevData.massage || [];

            if (isInterim) {
              // If interim message
              if (prevMsgs.length === 0) {
                return {
                  ...prevData,
                  massage: [
                    {
                      timestamp,
                      username: user,
                      message: [chunk],
                      displayName: display_name,
                      interim: true,
                    },
                  ],
                  summary: innerContent === "" ? null : innerContent,
                };
              }

              const lastMsg = prevMsgs[prevMsgs.length - 1];
              if (lastMsg.interim) {
                // update the last interim message
                const updated = [
                  ...prevMsgs.slice(0, -1),
                  {
                    ...lastMsg,
                    message: [chunk],
                  },
                ];
                return { ...prevData, massage: updated, summary: innerContent };
              } else {
                // add a new interim
                return {
                  ...prevData,
                  massage: [
                    ...prevMsgs,
                    {
                      timestamp,
                      username: user,
                      message: [chunk],
                      displayName: display_name,
                      interim: true,
                    },
                  ],
                  summary: innerContent === "" ? null : innerContent,
                };
              }
            } else {
              // --- FINAL MESSAGE ---
              if (prevMsgs.length > 0 && prevMsgs[prevMsgs.length - 1].interim) {
                // replace last interim with final
                const updated = [
                  ...prevMsgs.slice(0, -1),
                  {
                    timestamp,
                    username: user,
                    message: [chunk],
                    displayName: display_name,
                    interim: false,
                  },
                ];
                return { ...prevData, massage: updated, summary: innerContent };
              }

              // normal append for final
              return {
                ...prevData,
                massage: [
                  ...prevMsgs,
                  {
                    timestamp,
                    username: user,
                    message: [chunk],
                    displayName: display_name,
                    interim: false,
                  },
                ],
                summary: innerContent,
              };
            }
          });

          // setWordsAvailable(true);
        }

        // handle transcription meaning
        if (received.selected === "transcription") {
          setMeaning(received.massage.meaning);

        }

        // handle bot keep-alive logic (same as before)
        if (received.selected === "bot") {
          if (!isBotJoined) {
            setIsBotJoined(true);
          }
          if (received.keep_bot_alive === "timeout") {
            setDialogTitle(
              <span>
                <AccessTimeIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                We’ve hit the 2-hour mark. Still here with us?
              </span>
            );
            setOpenDialog(true);
          } else if (received.keep_bot_alive === "no_transcript") {
            setDialogTitle(
              <span>
                <BackHandOutlinedIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Are you still on the call?
              </span>
            );
            setOpenDialog(true);
          } else if (
            ["yes", "no", "no_response"].includes(received.keep_bot_alive)
          ) {
            setOpenDialog(false);
          } else if (received.keep_bot_alive === "Leave") {
            setBotLeaved(true);
          }
        }
      } catch (err) {
        console.error("socket parse error:", err);
      }
    };

    socket.onclose = () => {
      console.log("WebSocket connection closed.");
    };

    // Clean up the socket handlers on component unmount
    return () => {
      socket.onopen = null;
      socket.onmessage = null;
      socket.onclose = null;
      // setWordsAvailable(false); // Reset words availability
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  // 26-01-2024 sending word from react
  // useEffect(() => {
  //   if (socket) {
  //     if (transcript && !interimTranscript) {
  //       // Send the finalized transcript to the server
  //       console.log(interimTranscript);

  //       socket.send(
  //         JSON.stringify({
  //           message: transcript,
  //           action: "word",
  //           username: sessionData.username,
  //           display_name: sessionStorage.getItem('display_name')
  //         })
  //       );

  //       // Reset transcript after sending
  //       resetTranscript();
  //     }
  //   }
  // }, [transcript, interimTranscript, resetTranscript, socket]);

  // const intervalRef = useRef(null); // Reference for the interval

  // useEffect(() => {
  //   // Function to send the message
  //   const sendMessage = (message) => {
  //     if (message.trim()) {
  //       socket.send(
  //         JSON.stringify({
  //           message: message,
  //           action: "word",
  //           username: sessionData.username,
  //           display_name: sessionStorage.getItem("display_name"),
  //         })
  //       );
  //     }
  //   };

  //   if (socket) {
  //     // If there's an interim transcript (ongoing speech)
  //     if (interimTranscript) {
  //       setDiscussion(interimTranscript);  // Update discussion with interim transcript

  //       // let message = interimTranscript.split(" ");

  //       if(!isIntervalRunning){
  //         console.log("interval running");

  //         if (intervalRef.current) {
  //           console.log("Clearing previous timeout...");
  //           clearTimeout(intervalRef.current);
  //         }

  //         setIsIntervalRunning(true);
  //         intervalRef.current = setTimeout(() => {
  //           console.log("interval running from 2 sec");

  //           sendMessage(discussion);
  //           setDiscussion("");
  //           setIsIntervalRunning(false);
  //         }, 2000);
  //       }

  //       // If no interval is running, set up a timeout to send message after 5 seconds
  //     //  if(message.length > 10){
  //     //   message = []
  //     //   sendMessage(discussion);
  //     //   setDiscussion("");
  //     //  }
  //     }
  //     // When user stops speaking (finalized transcript)
  //     else if (transcript && !interimTranscript) {

  //       if (intervalRef.current) {
  //         clearTimeout(intervalRef.current); // Clear any existing timeout if the user stops speaking
  //         intervalRef.current = null;
  //       }

  //       // Send the finalized transcript immediately
  //       sendMessage(discussion);
  //       resetTranscript();  // Reset the transcript
  //       setDiscussion("");  // Clear discussion
  //       setIsIntervalRunning(false);  // Reset interval running status
  //     }
  //   }

  //   // Cleanup on component unmount
  //   return () => {
  //     if (intervalRef.current) {
  //       clearTimeout(intervalRef.current);
  //     }
  //   };
  // }, [transcript, interimTranscript, socket, sessionData, discussion]);

  // 25-02-2025
  // if (!browserSupportsSpeechRecognition) {
  //   return null
  // }

  // For counting how many words a user has clicked
  const handleWordCount = async () => {
    try {
      await axios.post(
        `${dashboard_backend}/usages/words-click-count/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handelMessage = (head) => {
    if (socket) {
      socket.send(
        JSON.stringify({
          message: "",
          word: head,
          action: "transcription",
          username: sessionData.username,
          display_name: sessionStorage.getItem("display_name"),
        })
      );
    }
    // socket.send(JSON.stringify({ "message": word[word.length-1],"username":sessionData.username}));
    handleWordCount();
  };

  const removeSpecialSymbols = (word) => {
    return word.replace(/[^a-zA-Z0-9 ]/g, "", ",", ".", "!", "?");
  };

  const handleTooltipToggle = (word, index, event, call, choosen) => {
    // If the same word is clicked, close the tooltip, else set the active word
    const cleanWord = removeSpecialSymbols(word);
    setTooltipHead(cleanWord);
    // const re = event.target.getBoundingClientRect();

    // setTop(re.top + 10 + window.scrollY);
    // setLeft(re.left + 20 + window.scrollX);

    if (activeTooltip === index && index !== 0) {
      setActiveTooltip(null);
      setType(call);
    } else if (index === 0) {
      setActiveTooltip(true);
      handelMessage(word);
      setType(call);
    } else {
      setActiveTooltip(index);
      handelMessage(word);
      setType(call);
    }
  };




  const handleMouseUp = (event, call, choosen) => {
    // Find the closest transcript-msg container to the event target
    const container =
      event.target.closest(".transcript-msg") ||
      event.target.closest(".summary");
    if (!container) {
      console.error("Container not found");
      return;
    }

    const selection = window.getSelection();
    const selectedText = selection.toString().trim();
    if (!selectedText || choosen !== "selected") return;

    // Get the anchor and focus nodes from the selection
    const anchorNode = selection.anchorNode;
    const focusNode = selection.focusNode;

    // Find the closest span for anchor and focus nodes
    const anchorSpan = (
      anchorNode.nodeType === Node.TEXT_NODE
        ? anchorNode.parentElement
        : anchorNode
    )?.closest("span");

    const focusSpan = (
      focusNode.nodeType === Node.TEXT_NODE
        ? focusNode.parentElement
        : focusNode
    )?.closest("span");

    if (!anchorSpan || !focusSpan) {
      console.warn("Anchor or focus span not found, using raw selected text");
      setTooltipHead(selectedText);
      if (activeTooltip) {
        setActiveTooltip(null);
        setType(call);
      } else {
        setActiveTooltip(true);
        handelMessage(selectedText);
        setType(call);
      }
      return;
    }

    // Get all spans within the specific container (the <p> tag)
    const wordSpans = Array.from(container.querySelectorAll("span"));
    if (!wordSpans.length) {
      console.error("No word spans found in container");
      return;
    }

    // Find the indices of the anchor and focus spans
    const startIndex = wordSpans.indexOf(anchorSpan);
    const endIndex = wordSpans.indexOf(focusSpan);
    if (startIndex === -1 || endIndex === -1) {
      console.error("Could not find start or end index of selected spans");
      return;
    }

    const lower = Math.min(startIndex, endIndex);
    const upper = Math.max(startIndex, endIndex);

    // Join the text content of all spans from lower to upper (inclusive)
    const adjustedText = wordSpans
      .slice(lower, upper + 1)
      .map((span) => span.textContent.trim())
      .join(" ")
      .trim();

    // Use the adjusted text in your tooltip and message handlers
    setTooltipHead(adjustedText);
    if (activeTooltip) {
      setActiveTooltip(null);
      setType(call);
    } else {
      setActiveTooltip(true);
      handelMessage(adjustedText);
      setType(call);
    }
  };

  const handleMouseUpWithDelay = (e, type, action) => {
    e.persist();
    // Clear the timer if a double click occurs
    clearTimeout(clickTimer.current);


    // Set a timer for single click
    clickTimer.current = setTimeout(() => {
      handleMouseUp(e, type, action);
    }, 200); // Adjust the delay as needed
  };

  const handleDoubleClick = (word, wordIndex, e, type, action) => {
    // Clear the single click timer
    clearTimeout(clickTimer.current);

    // e.style.backgroundColor = "#ffddb9";
    // Perform the double-click action
    handleTooltipToggle(word, wordIndex, e, type, action);
  };

  // For extension mute unmute
  // const handleListening = () => {
  //   if (listen) {
  //     SpeechRecognition.stopListening();
  //     setListen(false);
  //   } else {
  //     SpeechRecognition.startListening({ continuous: true, language: "en-US" });
  //     setListen(true);
  //   }
  // };



  const closeTooltip = () => {
    setActiveTooltip(null);
    setMeaning("");
  };

  const handleEdit = () => {
    setEdit(true);
  };

  const TypewriterEffect = ({ text, speed = 200 }) => {
    const [displayedText, setDisplayedText] = useState("");
    const words = text.split(" ");

    useEffect(() => {
      let index = 0;
      const interval = setInterval(() => {
        if (index < words.length) {
          setDisplayedText((prev) =>
            prev ? `${prev} ${words[index]}` : words[index]
          );
          index++;
        } else {
          clearInterval(interval);
        }
      }, speed);

      return () => clearInterval(interval);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text, speed]);

    return <p className="type-out">{displayedText}</p>;
  };

  const tooltipHtml = (word) => (
    <div
      className="w-[300px] px-3 py-2 rounded-2xl max-w-md mx-auto overflow-hidden bg-[#EDE6EE]"
      id="tooltip-container"
    >
      <h1 className="px-3 py-2 tooltip-head text-[black]">
        {capitalize(word)}
      </h1>
      {meaning && (
        <div className="flex flex-col">
          <div className="p-3 text-[#000] text-[16px] container">
            {!hasShownMeaning ? (
              <TypewriterEffect text={meaning || ""} />
            ) : (
              <Typography variant="body1" color="text.primary">
                {meaning}
              </Typography>
            )}
          </div>

          {/* loader */}

          {/* <div class="load-3">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div> */}

          {/* loader */}

          <div className="flex justify-center">
            <button
              onClick={() => closeTooltip()}
              className=" px-3 text-[#68548E] text-[16px] "
            >
              Close
            </button>
            <button
              onClick={() => handleEdit()}
              className="px-3 text-[#68548E] text-[16px]"
            >
              Change Meaning
            </button>
          </div>
        </div>
      )}
    </div>
  );

  // Add Liznr
  const [isAdded, setIsAdded] = useState(false);
  const userId = sessionStorage.getItem("user_id");
  const user_email = sessionStorage.getItem("user_email");
  const liznr_joined = JSON.parse(sessionStorage.getItem("liznr_added"));
  const [showNoCreditsDialog, setShowNoCreditsDialog] = useState(false);
  // For Adding Liznr to Live meetings
  const add_liznr = async () => {
    const roomcode = sessionStorage.getItem("roomcode");
    if (liznr_joined) {
      toast.info("Lizy has already joined the meeting");
      return;
    }
    const meetLink = sessionStorage.getItem("msLink");
    
    const data = {
      meeting_link: meetLink,
      user_id: userId,
      participants: user_email,
    };
    try {
      if (roomcode) {
        const response = await axios.post(
          `${dashboard_backend}/moms/add-liznr-bot/`,
          data,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data?.status === "Job triggered") {
            sessionStorage.setItem("liznr_added", JSON.parse(true));
            toast.success("Lizy will be joining within 2 minutes");
            setIsAdded(true);
          } else if (
            response.data?.status === "Bot Already Running" ||
            response.data?.status === "Bot already running" ||
            response.data?.status === "BotAlreadyRunning"
          ) {
            toast.info("Lizy is already added in this meeting.");
          } else if (
            response.data?.message === "No active Subscription" ||
            response.data?.message === "Reactivate your Subscription" ||
            response.data?.message === "No active Subscription" ||
            response.data?.message === "No Credits Available" ||
            response.data?.status === "No active subscription"
          ) {
            setShowNoCreditsDialog(true);
          } else if (response.data?.status) {
            toast.info(response.data?.status);
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handleUserResponse = (response) => {
    if (response) {
      if (socket) {
        socket.send(
          JSON.stringify({
            massage: [],
            selected: "",
            summary: "",
            discusion: {},
            username: "",
            display_name: "",
            action: "bot",
            keep_bot_alive: response,
          })
        );
      }
      setOpenDialog(false);
    } else {
      console.error("No response received from background script.");
    }
  };

  // const [searchActive, setSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // const handleToggleSearch = () => {
  //   setSearchActive(true);
  // };

  // const handleInputChange = (e) => {
  //   const input = e.target.value;
  //   const wordCount = input.trim().split(/\s+/).filter(Boolean).length;

  //   if (wordCount <= 10) {
  //     setSearchQuery(input);
  //   }
  // };
  // const handleCancelSearch = () => {
  //   setSearchActive(false);
  //   setSearchQuery("");
  // };

  const handleSearch = (e) => {
    if (searchQuery.trim()) {

      handleDoubleClick(searchQuery, 0, e, "transcript", "clicked");
      // Add your search logic here
    }
  };



  // Helper method to send messages to background script
  // function sendMessage(message) {
  //   return new Promise((resolve, reject) => {
  //     chrome.runtime.sendMessage(message, (response) => {
  //       if (chrome.runtime.lastError) {
  //         reject(new Error(chrome.runtime.lastError.message));
  //       } else {
  //         resolve(response);
  //       }
  //     });
  //   });
  // }







  const [activeTab, setActiveTab] = useState("transcript");
  const [loading, setLoading] = useState(false);
  const [insights, setInsights] = useState(null);


  const [infoMessage, setInfoMessage] = useState("");
  const handleGenerateInsights = async () => {
    setLoading(true);
    setInfoMessage(""); // clear any old message

    try {
      const response = await axios.post(
        `${ext_backend}get-ai-insights/`,
        {
          room_name: sessionStorage.getItem("roomcode"),
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );

      // If successful (status 200)
      const raw = response.data?.insights ?? response.data;

      const mapped = {
        whatToAskNext: raw.what_to_ask_next ?? [],
        factualMentions: raw.factual_mentions ?? [],
        detectedSignals: {
          interestLevel: raw.detected_signals?.interest_level ?? "Unknown",
          objections: raw.detected_signals?.objections ?? [],
          painPoints: raw.detected_signals?.pain_points ?? [],
        },
        smartResponses: raw.smart_responses ?? [],
        toneInsight: {
          confidence: raw.tone_insight?.confidence ?? "",
          buyerEmotion:
            raw.tone_insight?.participant_emotion ??
            raw.tone_insight?.buyer_emotion ??
            "",
        },
      };

      setInsights(mapped);
    } catch (error) {
      console.error("Error generating insights:", error);

      // ✅ Check for 404 here
      if (error.response && error.response.status === 404) {
        setInfoMessage("⚠️ Not enough transcript to analyze.");
        setTimeout(() => setInfoMessage(""), 3000);
      } else {
        setInfoMessage("Something went wrong while generating insights.");
        setTimeout(() => setInfoMessage(""), 3000);
      }
    } finally {
      setLoading(false);
    }
  };
  function openDashboard(dashboard_redirect, setShowNoCreditsDialog) {
  try {
    // --- 1️⃣ Chrome Extension environment ---
    if (typeof chrome !== "undefined" && chrome.tabs?.create) {
      chrome.tabs.create({ url: dashboard_redirect });
      setShowNoCreditsDialog(false);
      return;
    }

    // --- 2️⃣ Microsoft Teams environment ---
    if (window.microsoftTeams || microsoftTeams?.app) {
      // initialize if not already
      microsoftTeams.app.initialize().then(() => {
        microsoftTeams.app.openLink(dashboard_redirect);
      }).catch(() => {
        // fallback to window.open if something fails
        window.open(dashboard_redirect, "_blank");
      });
      setShowNoCreditsDialog(false);
      return;
    }

    // --- 3️⃣ Default fallback (browser) ---
    window.open(dashboard_redirect, "_blank");
    setShowNoCreditsDialog(false);

  } catch (err) {
    console.error("Error opening dashboard:", err);
    window.open(dashboard_redirect, "_blank");
    setShowNoCreditsDialog(false);
  }
}


  // ===========================================================================================================================================

  return (
    <>
      <div className="w-full h-full max-w-screen-xl mx-auto rounded-xl overflow-x-hidden">
        {showList && (
          <CustomTooltip
            title={tooltipHtml(tooltipHead)}
            open={activeTooltip}
            onClose={() => setActiveTooltip(null)}
            placement="top"
            disableFocusListener
            disableHoverListener
            disableTouchListener
          ></CustomTooltip>
        )}
        <Dialog
          open={showNoCreditsDialog}
          onClose={() => setShowNoCreditsDialog(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "20px", // More rounded, card-like
              maxWidth: 340,        // Compact width
              p: 1
            }
          }}
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: "#68548E", // Accent color like reference
              fontSize: "1.25rem",
              pb: 1
            }}
          >
            Out of Credits
          </DialogTitle>

          <DialogContent sx={{ textAlign: "center", px: 2 }}>
            {/* Image Section */}
            <img
              src={credits_exhausted}
              alt="No Credits"
              style={{
                width: "100%",
                maxHeight: "150px",
                objectFit: "contain",
                marginBottom: "16px"
              }}
            />

            <Typography
              variant="body1"
              color="text.primary"
              sx={{ fontSize: "0.95rem", fontWeight: 500 }}
            >
              You have no credits left. Please Recharge to continue using this
              feature.
            </Typography>
          </DialogContent>

          <DialogActions
            sx={{
              justifyContent: "center",
              pb: 2,
              px: 2,
              gap: 2
            }}
          >
            <button
              onClick={() => setShowNoCreditsDialog(false)}
              style={{
                flex: 1,
                backgroundColor: "#e0e0e0",
                color: "#333",
                border: "none",
                borderRadius: "25px", // pill-shaped button
                padding: "10px 0",
                fontWeight: 600,
                cursor: "pointer",
                fontSize: "12px"
              }}
            >
              Close
            </button>

            <button
              onClick={() => openDashboard(dashboard_redirect, setShowNoCreditsDialog)}
              style={{
                flex: 1,
                backgroundColor: "#68548E",
                color: "#fff",
                border: "none",
                borderRadius: "25px", // pill-shaped button
                padding: "10px 0",
                fontWeight: 600,
                cursor: "pointer",
                fontSize: "12px"
              }}
            >
              Recharge Now
            </button>
          </DialogActions>
        </Dialog>

        <KeepBotDialog
          open={openDialog}
          setOpen={setOpenDialog}
          response={handleUserResponse}
          title={dialogTitle}
        />

        {edit && (
          <EditModal
            word={tooltipHead}
            close={() => setEdit(false)}
            show={edit}
          />
        )}

        {showList && (
          <button
            onClick={() => setShowList(!showList)}
            className="absolute top-0 left-[10px] w-[25px] h-[25px] my-2 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300"
          >
            <ArrowBackIcon style={{ fontSize: "20px", color: "#333" }} />
          </button>
        )}

        {showList && (
          <button
            onClick={exitRoom}
            className="absolute top-0 left-[320px] w-[25px] h-[25px] my-2 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300"
          >
            <CallIcon style={{ fontSize: "20px", color: "#BA1A1A" }} />
          </button>
        )}

        {/* Main content container */}
        <div className="max-w-md mx-auto rounded-lg h-full flex flex-col">
          <div className={`text-gray-500 text-lg flex flex-col h-full`}>
            {!showList && (
              <div className="flex-none">
                {/* Your non-list view content remains unchanged */}
                <div className="flex justify-center p-2">
                  <div className="bg-[#f8f5fe] p-2 rounded-full">
                    <div className="p-3 w-[102px] h-[102px] bg-[#eae3fb] rounded-full">
                      <div className="text-[#fff] h-full bg-[#68558e] rounded-full flex justify-center items-center p-2">
                        <div className={isBotJoined && !botLeaved ? "spinner" : "muted"}>
                          <div className="rect1"></div>
                          <div className="rect2"></div>
                          <div className="rect3"></div>
                          <div className="rect4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="!text-[22px] text-center !leading-[28px] py-[20px] relative">
                  {isBotJoined && !botLeaved ? (
                    <p>
                      Lizning & generating
                      <span className="dots absolute"></span>
                    </p>
                  ) : (
                    <p>
                      {!botLeaved ? (
                        <>
                          Waiting for
                          <br /> virtual participant
                          <span className="dots absolute"></span>
                        </>
                      ) : (
                        "Lizy left the meeting"
                      )}
                    </p>
                  )}
                </div>

                <div className="btn-style flex justify-center p-4 relative">
                  <button
                    onClick={isListening ? handleStopListening : handleStartListening}
                    className={`w-[50px] h-[50px] !text-[#000000] btn-submit text-white border-2 border-gray-700 py-2 rounded-full m-2 ${isListening ? "hover:bg-[#f0f0f0]" : "hover:bg-[#fff1f1]"
                      }`}
                  >
                    <div className="microphone-btn flex justify-center">
                      <div className="microphone-info">
                        {isListening ? "Mute microphone" : "Unmute microphone"}
                      </div>
                      {isListening ? (
                        <i className="fa-solid fa-microphone"></i>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.71992 3.39023C8.71992 2.73023 9.25992 2.19023 9.91992 2.19023C10.5799 2.19023 11.1199 2.73023 11.1199 3.39023L11.1099 7.30023L12.9199 9.09023V3.49023C12.9199 1.83023 11.5799 0.490234 9.91992 0.490234C8.37992 0.490234 7.12992 1.65023 6.95992 3.14023L8.71992 4.90023V3.39023ZM16.9199 9.49023H15.2199C15.2199 10.0702 15.1199 10.6202 14.9499 11.1302L16.2199 12.4002C16.6599 11.5202 16.9199 10.5302 16.9199 9.49023ZM2.32992 1.35023L0.919922 2.76023L6.91992 8.76023V9.49023C6.91992 11.1502 8.25992 12.4902 9.91992 12.4902C10.1499 12.4902 10.3599 12.4602 10.5699 12.4102L12.2299 14.0702C11.5199 14.4002 10.7299 14.5902 9.91992 14.5902C7.15992 14.5902 4.61992 12.4902 4.61992 9.49023H2.91992C2.91992 12.9002 5.63992 15.7202 8.91992 16.2102V19.4902H10.9199V16.2102C11.8299 16.0802 12.6899 15.7602 13.4699 15.3102L17.6699 19.5102L19.0799 18.1002L2.32992 1.35023Z"
                            fill="#49454E"
                          />
                        </svg>
                      )}
                    </div>
                  </button>

                  <button
                    onClick={exitRoom}
                    className="w-[50px] h-[50px] btn-submit bg-[#BA1A1A] text-white px-3 rounded-full hover:bg-red-700 m-2"
                  >
                    <div className="exit-call">
                      <p>Exit Liznr</p>
                    </div>
                    <svg
                      width="20"
                      height="10"
                      viewBox="0 0 24 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.59 4.09031C19.64 4.60031 20.63 5.24031 21.55 6.00031L20.48 7.07031C19.9 6.60031 19.27 6.18031 18.6 5.80031V4.09031M5.4 4.09031V5.79031C4.75 6.16031 4.12 6.58031 3.53 7.06031L2.46 5.99031C3.37 5.24031 4.36 4.61031 5.4 4.09031ZM12 0.570312C7.46 0.570312 3.34 2.35031 0.29 5.24031C0.11 5.42031 0 5.67031 0 5.95031C0 6.23031 0.11 6.48031 0.29 6.65031L2.77 9.13031C2.95 9.31031 3.2 9.42031 3.48 9.42031C3.75 9.42031 4 9.32031 4.18 9.14031C4.97 8.41031 5.86 7.78031 6.84 7.29031C7.17 7.13031 7.4 6.78031 7.4 6.39031V3.29031C8.85 2.82031 10.4 2.57031 12 2.57031C13.6 2.57031 15.15 2.82031 16.59 3.30031V6.40031C16.59 6.80031 16.82 7.14031 17.15 7.30031C18.13 7.79031 19.03 8.41031 19.82 9.15031C20 9.32031 20.25 9.43031 20.52 9.43031C20.8 9.43031 21.05 9.32031 21.23 9.14031L23.71 6.66031C23.89 6.48031 24 6.23031 24 5.95031C24 5.67031 23.89 5.42031 23.71 5.24031C20.66 2.35031 16.54 0.570312 12 0.570312Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>

                <div>

                  <button
                    onClick={handleToggleClick}
                    className="w-full !rounded-full p-2 !bg-[#68548E] !normal-case !text-[#ffffff]"
                  >
                    Display notes
                  </button>
                </div>
                <div className="mt-2">
                  <button
                    onClick={add_liznr}
                    disabled={isAdded}
                    className="w-full !rounded-full p-2 !bg-[#68548E] !normal-case !text-[#ffffff] disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Add Lizy To Live Meeting
                  </button>
                </div>
              </div>
            )}

            {/* Transcript and Summary sections - only when showList is true */}
            {showList && (
              <div className="tab-container" style={{ display: "flex", flexDirection: "column", height: "100%", background: "#ffffff" }}>
                {/* Compact Modern Tab Header */}
                {/* 1. Always-visible Ask Lizy search bar above tabs */}
                <div style={{ display: "flex", justifyContent: "center", padding: "8px 0" }}>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => {
                      const val = e.target.value;
                      setSearchQuery(val);
                      if (val.startsWith("@")) {
                        // setSearchFocused("transcript");
                        setSearchInput(val.slice(1));
                      } else {
                        // setSearchFocused("ai");
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        if (searchQuery.startsWith("@")) {
                          setSearchText(searchQuery.slice(1));
                          setCurrentMatchIndex(0);
                        } else {
                          handleSearch(e);
                        }
                      }
                    }}
                    placeholder={searchPlaceholder}
                    className="border border-gray-300 rounded-full px-3 py-1 text-xs bg-gray-200 outline-none"
                    style={{ width: "240px" }}
                  />
                </div>


                {/* 2. Tabs immediately below, with minimal padding */}
                <div
                  style={{
                    display: "flex",
                    padding: "0 8px",
                    gap: "8px", // Separation between tabs
                    position: "relative",
                  }}
                >
                  <button
                    onClick={() => setActiveTab("transcript")}
                    style={{
                      flex: 1,
                      padding: "4px 0",
                      background: "transparent",
                      color: activeTab === "transcript" ? "#007bff" : "#666",
                      border: "none",
                      cursor: "pointer",
                      fontWeight: activeTab === "transcript" ? 600 : 500,
                      fontSize: "12px",
                      lineHeight: "1.2",
                      borderBottom: activeTab === "transcript"
                        ? "1.5px solid #007bff"
                        : "1.5px solid transparent",
                      transition: "all 0.2s ease",
                      borderRadius: "4px 4px 0 0",
                      opacity: activeTab === "transcript" ? 1 : 0.7,
                    }}
                    onMouseEnter={(e) => {
                      if (activeTab !== "transcript") {
                        e.currentTarget.style.opacity = "0.9";
                        e.currentTarget.style.backgroundColor = "rgba(0, 123, 255, 0.03)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeTab !== "transcript") {
                        e.currentTarget.style.opacity = "0.7";
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    Transcript
                  </button>

                  {/* Vertical Separator */}
                  <div
                    style={{
                      width: "1px",
                      background: "linear-gradient(to bottom, transparent, #e0e0e0, transparent)",
                      margin: "4px 0",
                    }}
                  />

                  <button
                    onClick={() => setActiveTab("insights")}
                    style={{
                      flex: 1,
                      padding: "4px 0",
                      background: "transparent",
                      color: activeTab === "insights" ? "#007bff" : "#666",
                      border: "none",
                      cursor: "pointer",
                      fontWeight: activeTab === "insights" ? 600 : 500,
                      fontSize: "12px",
                      lineHeight: "1.2",
                      borderBottom: activeTab === "insights"
                        ? "1.5px solid #007bff"
                        : "1.5px solid transparent",
                      transition: "all 0.2s ease",
                      borderRadius: "4px 4px 0 0",
                      opacity: activeTab === "insights" ? 1 : 0.7,
                    }}
                    onMouseEnter={(e) => {
                      if (activeTab !== "insights") {
                        e.currentTarget.style.opacity = "0.9";
                        e.currentTarget.style.backgroundColor = "rgba(0, 123, 255, 0.03)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeTab !== "insights") {
                        e.currentTarget.style.opacity = "0.7";
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>✨</span> AI Analysis
                  </button>
                </div>




                {/* Tab Content */}
                <div style={{ flexGrow: 1, overflow: "hidden", padding: "6px" }}>
                  {activeTab === "transcript" && (
                    <div className="flex flex-col h-full" style={{ gap: "6px" }}>
                      {/* Transcript Area - 60% height */}
                      <div className="flex-none" style={{ height: "60%" }}>
                        <div className="transcript-container h-full flex flex-col" style={{ position: 'relative', zIndex: 1 }}>
                          {activeTooltip && type === "transcript" && (
                            <div
                              className="backdrop"
                              style={{
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                              }}
                              onClick={() => closeTooltip()}
                            ></div>
                          )}



                          <div className="flex-grow min-h-0 overflow-hidden relative">
                            <div
                              className="leading-[16px] h-full overflow-y-auto transcription-area text-[16px] relative"
                              style={{
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                color: "#333",
                                borderRadius: "6px",
                                background: "#fafafa",
                                border: "1px solid #e8e8e8",
                                padding: "6px",
                                fontSize: "11px",
                              }}
                              ref={transcriptContainerRef}
                              onScroll={handleScroll}
                            >
                              <ul style={{ position: "relative", margin: 0, padding: 0, listStyle: "none" }}>
                                <li>
                                  <ul style={{ margin: 0, padding: 0, listStyle: "none" }}
                                    onMouseUp={(e) =>
                                      handleMouseUpWithDelay(e, "transcript", "selected")
                                    }
                                  >
                                    {(() => {
                                      tempRefs.current = [];
                                      return null;
                                    })()}

                                    {receivedData.massage.map((msg, index) => {
                                      // const userColor = generateColorFromUsername(
                                      //   msg.displayName ? msg.displayName : msg.username
                                      // );

                                      // Visual style based on interim/final
                                      const messageStyle = {
                                        opacity: msg.interim ? 0.5 : 1,
                                        fontStyle: msg.interim ? "italic" : "normal",
                                        transition: "opacity 0.2s ease, font-style 0.2s ease",
                                        color: msg.interim ? "#777" : "#555",
                                      };

                                      return (
                                        <li
                                          key={index}
                                          style={{
                                            marginBottom: "8px",
                                            borderLeft: msg.interim ? "2px solid #d6b4fc" : "2px solid transparent",
                                            paddingLeft: "4px",
                                            background: msg.interim ? "#f9f6ff" : "transparent",
                                            transition: "all 0.2s ease",
                                          }}
                                        >
                                          {/* Header */}
                                          <div className="flex items-center" style={{ marginBottom: "2px", gap: "4px" }}>
                                            <AccountCircleRoundedIcon style={{ fontSize: "14px", color: "#888" }} />
                                            <span
                                              className="displayName"
                                              style={{
                                                fontSize: "11px",
                                                fontWeight: "600",
                                                color: "#333"
                                              }}
                                            >
                                              {msg.displayName ? msg.displayName : msg.username}
                                            </span>
                                            <span
                                              style={{
                                                width: "2px",
                                                height: "2px",
                                                background: "#ccc",
                                                borderRadius: "50%"
                                              }}
                                            ></span>
                                            <span style={{ fontSize: "10px", color: "#999" }}>
                                              {msg.timestamp}
                                            </span>
                                            {msg.interim && (
                                              <span style={{ fontSize: "10px", color: "#a27ee5", marginLeft: "4px" }}>
                                                (listening...)
                                              </span>
                                            )}
                                          </div>

                                          {/* Message Text */}
                                          <p
                                            className="transcript-msg tooltip-target leading-[15px]"
                                            style={{
                                              ...messageStyle,
                                              wordWrap: "break-word",
                                              overflowWrap: "break-word",
                                              whiteSpace: "normal",
                                              margin: 0,
                                              fontSize: "11px",
                                            }}
                                          >
                                            {msg.message.map((sentence, sentenceIndex) =>
                                              sentence.split(" ").map((word, wordIndex) => {
                                                const cleanedWord = word.toLowerCase().replace(/[.,!?]/g, "");
                                                const search = searchText.toLowerCase().trim();
                                                const isMatch = search && cleanedWord.includes(search);
                                                const isCurrentMatchIndex =
                                                  tempRefs.current.length === currentMatchIndex;
                                                const spanRef = isMatch ? React.createRef() : null;
                                                if (isMatch) tempRefs.current.push(spanRef);

                                                return (
                                                  <span
                                                    key={`${index}-${sentenceIndex}-${wordIndex}`}
                                                    ref={isMatch ? spanRef : null}
                                                    style={{
                                                      backgroundColor: isMatch
                                                        ? (isCurrentMatchIndex ? "#ffeb3b" : "#fff9c4")
                                                        : "transparent",
                                                      borderRadius: "2px",
                                                      padding: "0 1px",
                                                      cursor: "pointer",
                                                      position: "relative",
                                                    }}
                                                    className="tooltip-target selection:bg-[#ffddb9]"
                                                    onDoubleClick={(e) =>
                                                      handleDoubleClick(
                                                        word,
                                                        wordIndex,
                                                        e,
                                                        "transcript",
                                                        "clicked"
                                                      )
                                                    }
                                                  >
                                                    {word + " "}
                                                  </span>
                                                );
                                              })
                                            )}
                                          </p>
                                        </li>
                                      );
                                    })}
                                    <div ref={bottomRef} />
                                  </ul>
                                </li>
                              </ul>
                            </div>
                            {/* Compact Scroll Button */}
                            {showScrollButton && (
                              <button
                                onClick={scrollToBottom}
                                style={{
                                  bottom: "8px",
                                  right: "8px",
                                  position: "absolute",
                                  padding: "4px",
                                  borderRadius: "6px",
                                  background: "white",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                  border: "1px solid #e0e0e0",
                                  cursor: "pointer",
                                  transition: "all 0.15s",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = "#fafafa";
                                  e.currentTarget.style.transform = "scale(1.05)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = "white";
                                  e.currentTarget.style.transform = "scale(1)";
                                }}
                              >
                                <ChevronDown style={{ width: "14px", height: "14px", color: "#666" }} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* What Happened So Far - 40% height */}
                      <div className="flex-none" style={{ height: "40%", overflow: "hidden" }}>
                        {activeTooltip && type === "summary" && (
                          <div
                            className="backdrop"
                            style={{
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                            }}
                            onClick={() => closeTooltip()}
                          ></div>
                        )}
                        <h1
                          className="what-happen"
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "4px",
                            textAlign: "left",
                            lineHeight: "1.2"
                          }}
                        >
                          What happened so far?
                        </h1>
                        <div
                          className="summary tooltip-target w-full text-justify leading-[1.4] overflow-y-auto"
                          style={{
                            height: "calc(100% - 20px)",
                            fontSize: "11px",
                            wordBreak: "break-word",
                            background: "#fafafa",
                            border: "1px solid #e8e8e8",
                            borderRadius: "6px",
                            padding: "6px",
                            color: "#555"
                          }}
                          onMouseUp={(e) =>
                            handleMouseUpWithDelay(e, "summary", "selected")
                          }
                        >
                          {receivedData.summary && (<span className='ai-label text-xs text-[#6b7280] italic'>AI generated summary</span>)}
                          <br />
                          {receivedData.summary &&
                            receivedData.summary !== "" &&
                            receivedData.summary.split(" ").map((item, index) => (
                              <span
                                key={index}
                                className="selection:bg-[#ffddb9]"
                                style={{ cursor: "pointer" }}
                                onDoubleClick={(e) =>
                                  handleDoubleClick(
                                    item,
                                    index,
                                    e,
                                    "summary",
                                    "clicked"
                                  )
                                }
                              >
                                {item}{" "}
                              </span>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "insights" && (
                    <div
                      className="assistant-panel"
                      style={{
                        width: "100%",
                        height: "100%",
                        background: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        fontFamily: "system-ui, sans-serif",
                      }}
                    >
                      {/* Header */}
                      <div
                        className="assistant-header"
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        <div
                          className="button-group"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "0.4rem 0",
                          }}
                        >
                          <div
                            className="gradient-border"
                            style={{
                              borderRadius: "999px",
                              padding: "1.5px",
                              background: "linear-gradient(90deg, #00E0C6, #5F3BFF)",
                              display: "inline-block",
                              boxShadow: "0 1px 3px rgba(95,59,255,0.12)",
                              cursor: "pointer",
                              opacity: loading ? 0.75 : 1,
                              transition: "transform 0.15s ease, box-shadow 0.15s ease",
                            }}
                          >
                            <button
                              onClick={handleGenerateInsights}
                              disabled={loading}
                              aria-label="Generate"
                              type="button"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                padding: "6px 18px",
                                background: "#ffffff",
                                borderRadius: "999px",
                                minHeight: "30px",
                                border: "none",
                                outline: "none",
                                fontFamily: "'Poppins', system-ui, sans-serif",
                                fontWeight: 600,
                                fontSize: "13px",
                                color: "#2BB7F0",
                                lineHeight: 1,
                                transition: "all 0.2s ease",
                              }}
                            >
                              {/* Animated Icon */}
                              <span
                                style={{
                                  width: "17px",
                                  height: "17px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transform: loading ? "rotate(360deg)" : "rotate(0deg)",
                                  transition: "transform 0.8s ease-in-out",
                                }}
                              >
                                <svg
                                  viewBox="0 0 24 24"
                                  width="17"
                                  height="17"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                >
                                  <defs>
                                    <linearGradient id="regenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                      <stop offset="0%" stopColor="#00E0C6" />
                                      <stop offset="100%" stopColor="#5F3BFF" />
                                    </linearGradient>
                                  </defs>
                                  <path
                                    d="M12 2a10 10 0 1 0 9.5 13h-2a8 8 0 1 1-7.5-10v3l4-4-4-4v3Z"
                                    fill="url(#regenGradient)"
                                  />
                                  {/* subtle sparkle on top-right */}
                                  <circle cx="18" cy="6" r="1.5" fill="url(#regenGradient)" opacity="0.7" />
                                </svg>
                              </span>

                              {/* Label */}
                              <span
                                style={{
                                  background: "linear-gradient(90deg, #00E0C6, #5F3BFF)",
                                  WebkitBackgroundClip: "text",
                                  WebkitTextFillColor: "transparent",
                                  letterSpacing: "0.3px",
                                  display: "inline-block",
                                }}
                              >
                                {loading
                                  ? "Generating..."
                                  : insights
                                    ? "Regenerate"
                                    : "Generate"}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>





                      {infoMessage && (
                        <div
                          style={{
                            textAlign: "center",
                            color: "#b45309",
                            fontSize: "0.8rem",
                            padding: "0.4rem",
                            background: "#fff8e1",
                            borderRadius: "6px",
                            margin: "0.5rem auto",
                            width: "90%",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                            transition: "opacity 0.3s ease-in-out",
                          }}
                        >
                          {infoMessage}
                        </div>
                      )}
                      {/* Loading Indicator */}
                      {loading && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0.5rem",
                            minHeight: "80px", // optional: ensures vertical centering area
                          }}
                        >
                          <StarLoader size={50} />
                        </div>
                      )}



                      {/* Main Insights Sections */}
                      {!loading && insights && (
                        <div
                          style={{
                            flex: 1,
                            overflowY: "auto",
                            background: "#fafafa",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                          }}
                          className="hide-scrollbar"
                        >
                          {/* Ask Now */}
                          <div
                            className="section"
                            style={{
                              margin: "0.75rem 0",
                              borderRadius: "10px",
                              padding: "1rem",
                              background: "linear-gradient(135deg,#eaf3ff,#fff)",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                          >
                            <h3
                              style={{
                                fontSize: "0.95rem",
                                fontWeight: "600",
                                color: "#004aad",
                                marginBottom: "0.5rem",
                              }}
                            >
                              🧩 Ask Now
                            </h3>
                            <ul
                              style={{
                                fontSize: "0.82rem",
                                color: "#444",
                                paddingLeft: "1rem",
                                lineHeight: "1.6",
                                listStyleType: "disc",
                              }}
                            >
                              {insights.whatToAskNext.length > 0 ? (
                                insights.whatToAskNext.map((q, i) => (
                                  <li
                                    key={i}
                                    style={{
                                      marginBottom: "0.4rem",
                                      background: "#f8faff",
                                      padding: "0.4rem 0.6rem",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    {q}
                                  </li>
                                ))
                              ) : (
                                <li style={{ color: "#777", fontStyle: "italic" }}>
                                  No suggested questions available.
                                </li>
                              )}
                            </ul>
                          </div>

                          {/* Smart Responses */}
                          <div
                            className="section"
                            style={{
                              margin: "0.75rem 0",
                              borderRadius: "10px",
                              padding: "1rem",
                              background: "linear-gradient(135deg,#f3eaff,#fff)",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                          >
                            <h3
                              style={{
                                fontSize: "0.95rem",
                                fontWeight: "600",
                                color: "#6a1b9a",
                                marginBottom: "0.5rem",
                              }}
                            >
                              💬 Suggested Response
                            </h3>
                            <ul
                              style={{
                                fontSize: "0.82rem",
                                color: "#444",
                                paddingLeft: "1rem",
                                lineHeight: "1.6",
                                listStyleType: "disc",
                              }}
                            >
                              {insights.smartResponses.length > 0 ? (
                                insights.smartResponses.map((r, i) => (
                                  <li
                                    key={i}
                                    style={{
                                      marginBottom: "0.4rem",
                                      background: "#f9f3ff",
                                      padding: "0.4rem 0.6rem",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    {r}
                                  </li>
                                ))
                              ) : (
                                <li style={{ color: "#777", fontStyle: "italic" }}>
                                  No smart responses available.
                                </li>
                              )}
                            </ul>
                          </div>

                          {/* Tone / Team Pulse */}
                          <div
                            className="section"
                            style={{
                              margin: "0.75rem 0",
                              borderRadius: "10px",
                              padding: "1rem",
                              background: "linear-gradient(135deg,#fff7e6,#fff)",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                          >
                            <h3
                              style={{
                                fontSize: "0.95rem",
                                fontWeight: "600",
                                color: "#b76b00",
                                marginBottom: "0.5rem",
                              }}
                            >
                              🎯 Team Insight
                            </h3>
                            <ul
                              style={{
                                fontSize: "0.82rem",
                                color: "#444",
                                paddingLeft: "1rem",
                                lineHeight: "1.6",
                              }}
                            >
                              <li>
                                <strong style={{ color: "#222" }}>Overall Tone:</strong>{" "}
                                {Array.isArray(insights.toneInsight.buyerEmotion)
                                  ? insights.toneInsight.buyerEmotion
                                    .map((p) => `${p.name}: ${p.emotion}`)
                                    .join(" • ")
                                  : insights.toneInsight.buyerEmotion || "Neutral"}
                              </li>
                              {/* <li>
                                <strong style={{ color: "#222" }}>Confidence:</strong>{" "}
                                {insights.toneInsight.confidence || "N/A"}
                              </li> */}
                            </ul>
                          </div>

                          {/* Factual Mentions */}
                          <div
                            className="section"
                            style={{
                              margin: "0.75rem 0",
                              borderRadius: "10px",
                              padding: "1rem",
                              background: "linear-gradient(135deg,#e7fbee,#fff)",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                          >
                            <h3
                              style={{
                                fontSize: "0.95rem",
                                fontWeight: "600",
                                color: "#0b7a37",
                                marginBottom: "0.5rem",
                              }}
                            >
                              📈 Factual Mentions
                            </h3>
                            <ul
                              style={{
                                fontSize: "0.82rem",
                                color: "#444",
                                paddingLeft: "1rem",
                                lineHeight: "1.6",
                                listStyleType: "disc",
                              }}
                            >
                              {insights.factualMentions?.length > 0 ? (
                                insights.factualMentions.map((item, i) => (
                                  <li
                                    key={i}
                                    style={{
                                      marginBottom: "0.4rem",
                                      background: "#f6fff8",
                                      padding: "0.4rem 0.6rem",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    {item}
                                  </li>
                                ))
                              ) : (
                                <li style={{ color: "#777", fontStyle: "italic" }}>
                                  No factual mentions detected.
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}



                      {/* Footer */}
                      <div
                        className="footer"
                        style={{
                          marginTop: "auto",
                          borderTop: "1px solid #eee",
                          textAlign: "center",
                          fontSize: "0.7rem",
                          color: "#999",
                        }}
                      >
                        Powered by <b>Liznr AI</b>
                      </div>
                    </div>
                  )}

                </div>
              </div>

            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default VoiceToText;
